var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "lit", "./utils/theme", "i18n/i18n"], function (require, exports, lit_1, theme_1, i18n_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Icon = exports.normalizeIconDataUri = void 0;
    exports.renderIcon = renderIcon;
    i18n_1 = __importDefault(i18n_1);
    const normalizeIconDataUri = (dataUri) => {
        if (dataUri.trim().startsWith("<svg")) {
            return ("data:image/svg+xml;charset=utf-8," +
                encodeURIComponent(dataUri)
                    .replace(/'/g, "%27")
                    .replace(/"/g, "%22"));
        }
        return dataUri;
    };
    exports.normalizeIconDataUri = normalizeIconDataUri;
    class Icon {
        constructor(icon) {
            this.data = "";
            this.type = "";
            this.themeable = false;
            if (icon && "dataUri" in icon) {
                this.data = icon.dataUri;
                this.type = "resource";
            }
            if (icon && "svg" in icon) {
                this.data = icon.svg;
                this.type = "svg";
            }
            if (icon && "html" in icon) {
                this.data = icon.html;
                this.type = "svg";
                this.themeable = icon.themeable;
            }
            if (icon && "class" in icon) {
                this.data = icon.class;
                this.type = "fa";
                this.themeable = icon.themeable;
            }
        }
        render(options = {}) {
            if (!this.themeable && this.type != "fa") {
                return (0, lit_1.html) `<img src="${(0, exports.normalizeIconDataUri)(this.data)}" class="mb-icon" alt="${options.altText}">`;
            }
            const iconStyle = (0, lit_1.html) `
      <style>
        .mb-icon > * {
          width: 100%;
          height: 100%;
          display: block;
        }
      </style>
    `;
            let color = options.color;
            let themeableStyle = "display:block;";
            if (color && this.themeable) {
                themeableStyle += "color: " + color;
                if (this.type == "svg") {
                    if (this.data.includes('fill=')) {
                        this.data = this.data.replace(/fill=".*?"/g, `fill="${color}"`);
                    }
                    else {
                        this.data = this.data.replace('<svg', `<svg fill="${color}"`);
                    }
                }
            }
            if (this.type == "fa") {
                return (0, lit_1.html) `
      ${iconStyle}
      <span class="mb-icon"
        role="img"
        aria-label=${options.altText}
        style=${themeableStyle}>
        <i class="${this.data}"></i>
      </span>`;
            }
            if (this.type == "svg") {
                const svgDataUri = `data:image/svg+xml;base64,${btoa(this.data)}`;
                return (0, lit_1.html) `
      ${iconStyle}
      <span class="mb-icon"
        role="img"
        aria-label=${options.altText}
        style=${themeableStyle}
      >
        <img
        src=${svgDataUri}
        class="mb-icon"
        role="img"
        alt=${options.altText}
        />
      </span>`;
            }
            return (0, lit_1.html) ``;
        }
    }
    exports.Icon = Icon;
    function renderIcon(icons, key, opts = {}) {
        if (!icons) {
            console.warn('No icons provided for renderIcon');
            return lit_1.nothing;
        }
        const iconData = icons[key];
        if (!iconData) {
            console.warn(`Icon key "${key}" not found in icons`);
            return lit_1.nothing;
        }
        const resolvedColor = opts.color ||
            (0, theme_1.resolveCssVarValue)(opts.fallbackColor || 'currentColor', {}) ||
            'currentColor';
        const colorString = typeof resolvedColor === 'number' ? resolvedColor.toString() : String(resolvedColor);
        const iconOptions = {
            color: colorString,
            altText: opts.altText || (0, i18n_1.default)('Icon')
        };
        const iconEl = new Icon(iconData).render(iconOptions);
        return (0, lit_1.html) `<span aria-hidden="true">${iconEl}</span>`;
    }
});
